import type { HtmlAttributes } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { ScrollableSections } from './scrollable-sections.js';

/**
 * Props for the SectionsContainer component
 */
export interface SectionsContainerProps extends HtmlAttributes {
  onSectionChange?: (section: string) => void;

  /** Registry section group whose sub-sections to list. See ScrollableSections. */
  sectionGroupKey?: string;
}

/**
 * Component that displays sections in a horizontally scrollable container
 * with fade-out effect on the edges
 */
export const SectionsContainer = ({
  className,
  onSectionChange,
  sectionGroupKey,
  ...props
}: SectionsContainerProps): ReactElement => {
  return (
    <ScrollableSections
      className={twMerge(className)}
      onSectionChange={onSectionChange || (() => {})}
      {...(sectionGroupKey === undefined ? {} : { sectionGroupKey })}
      {...props}
    />
  );
};
